import { render, staticRenderFns } from "./GiveawayForm.vue?vue&type=template&id=171f17e1&scoped=true"
import script from "./GiveawayForm.vue?vue&type=script&lang=js"
export * from "./GiveawayForm.vue?vue&type=script&lang=js"
import style0 from "./GiveawayForm.vue?vue&type=style&index=0&id=171f17e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f17e1",
  null
  
)

export default component.exports